import { useEffect, useState } from "react";
import EventBody from "./EventBody";
import EventHeader from "./EventHeader";
import { getSection2 } from "../../../api/contactPage/sections2";
import { IEvents } from "../../../models/IEvents";
import { parseApiDate } from "../../../utils/date";

const Events = () => {
  const [eventsData, setEventsData] = useState<IEvents[]>();
  const [headerData, setHeaderData] = useState<{
    header: string;
    description: string;
    header_image?: any;
  } | null>(null);

  const fetchEventsData = async () => {
    try {
      const page = "events";
      const dataFromAPI = getSection2(page);
      const data = (await dataFromAPI).finalData;

      // const dataFromAPI2 = getSection2("eventsHeader");
      // const data2 = (await dataFromAPI2).finalData;

      // if (data.data.length > 0) {
      setHeaderData({
        header: data.data.Header,
        description: data.data.Sub_header,
        header_image: "",
      });
      // }

      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const startDate = new Date(today);
      startDate.setDate(today.getDate() - 2);

      const upcoming = data.data.events.filter((event: IEvents) => {
        const baseDateString = event.endDate || event.startDate;
        if (!baseDateString) return false;

        const eventDate = parseApiDate(baseDateString);
        if (isNaN(eventDate.getTime())) return false;

        eventDate.setHours(0, 0, 0, 0);
        return eventDate >= startDate;
      });

      setEventsData(upcoming);
    } catch (error) {
      console.error("Failed to fetch events", error);
    }
  };

  useEffect(() => {
    fetchEventsData();
  }, []);

  return (
    <div className="flex flex-col overflow-y-auto md:p-8 p-4 md:px-12">
      {headerData && (
        <EventHeader
          heading={headerData.header}
          desc={headerData.description}
          heading_image={headerData.header_image ?? ""}
        />
      )}

      {eventsData && <EventBody data={eventsData} />}
    </div>
  );
};

export default Events;
